import React, { useCallback } from "react";
import { createForm } from "@formily/core";
import { createSchemaField } from "@formily/react";
import {
  Form,
  FormItem,
  Input,
  Password,
  Submit,
  FormButtonGroup,
} from "@formily/antd";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import { Card, Space } from "antd";
import styles from "./index.module.less";

const normalSchema = {
  type: "object",
  properties: {
    office_phone: {
      type: "string",
      title: "办公室电话",
      required: true,
      "x-decorator": "FormItem",
      "x-component": "Input",
      "x-component-props": {
        placeholder: "请输入办公室电话",
      },
    },
    director_name: {
      type: "string",
      title: "负责人",
      required: true,
      "x-decorator": "FormItem",
      "x-component": "Input",
      "x-component-props": {
        placeholder: "请输入负责人姓名",
      },
    },
    director_job: {
      type: "string",
      title: "负责人职位",
      required: true,
      "x-decorator": "FormItem",
      "x-component": "Input",
      "x-component-props": {
        placeholder: "请输入负责人职位",
      },
    },
    director_phone: {
      type: "string",
      title: "负责人电话",
      required: true,
      format: "phone",
      "x-decorator": "FormItem",
      "x-component": "Input",
      "x-component-props": {
        placeholder: "请输入负责人电话",
      },
    },
    name: {
      type: "string",
      title: "联系人",
      required: true,
      "x-decorator": "FormItem",
      "x-component": "Input",
      "x-component-props": {
        placeholder: "请输入联系人姓名",
      },
    },
    job: {
      type: "string",
      title: "职位",
      required: true,
      "x-decorator": "FormItem",
      "x-component": "Input",
      "x-component-props": {
        placeholder: "请输入联系人职位",
      },
    },
    phone: {
      type: "string",
      title: "电话",
      required: true,
      format: "phone",
      "x-decorator": "FormItem",
      "x-component": "Input",
      "x-component-props": {
        placeholder: "请输入联系人电话",
      },
    },
    password: {
      type: "string",
      title: "密码",
      required: true,
      format: "password",
      "x-decorator": "FormItem",
      "x-component": "Password",
      "x-component-props": {
        checkStrength: true,
      },
      "x-reactions": [
        {
          dependencies: [".confirm_password"],
          fulfill: {
            state: {
              selfErrors:
                '{{$deps[0] && $self.value && $self.value !== $deps[0] ? "确认密码不匹配" : ""}}',
            },
          },
        },
      ],
    },
    confirm_password: {
      type: "string",
      title: "确认密码",
      required: true,
      format: "password",
      "x-decorator": "FormItem",
      "x-component": "Password",
      "x-component-props": {
        checkStrength: true,
      },
      "x-reactions": [
        {
          dependencies: [".password"],
          fulfill: {
            state: {
              selfErrors:
                '{{$deps[0] && $self.value && $self.value !== $deps[0] ? "确认密码不匹配" : ""}}',
            },
          },
        },
      ],
    },
  },
};
const SchemaField = createSchemaField({
  components: {
    FormItem,
    Input,
    Password,
  },
});
function Profile() {
  const loading = useSelector(
    (state) => state.loading.effects.user.updateProfile
  );

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const normalForm = createForm({
    validateFirst: true,
  });
  const loginHandler = useCallback(
    async (values) => {
      const url = await dispatch.user.updateProfile(values);
      if (url) navigate(url);
    },
    [dispatch, navigate]
  );

  return (
    <div className={styles.profileContainer}>
      <Card title="请补充信息" bordered={false} className="profile-form">
        <Form
          form={normalForm}
          labelCol={8}
          wrapperCol={14}
          onAutoSubmit={loginHandler}
        >
          <SchemaField schema={normalSchema} />
          <FormButtonGroup.FormItem>
            <Space size="large">
              <Submit loading={loading}>确认</Submit>
              <Link to={"/"}>重新登录</Link>
            </Space>
          </FormButtonGroup.FormItem>
        </Form>
      </Card>
    </div>
  );
}
export default Profile;
